<template>
  <div class="AccessApiBox">
		<Nav />
		<div class="_CONT">
			<div class="AccessApi1">
				<div class="_AccessTop">
					<div class="_top">
						<div class="_left">
							<p class="_title">获取API</p>
							<p class="_cont">如果已有套餐无可选项，您可以至套餐页购买短效代理或独享代理	如果当前账号余额为0请先充值</p>
						</div>
						<div class="_right">
							<p class="_label">用户基本信息</p>
							<p class="_p1">当前账户余额（元）</p>
							<p class="_p2" v-if="infoData">{{infoData.balance_alias}}</p>
							<p class="_right_button" @click.stop="jumpTopup()">立即充值</p>
						</div>
					</div>
					<div class="_bot">
						<div class="_left">
							<span><strong class="red">*</strong>已有套餐：</span>
							<el-select
								class="_selects"
								v-model="package_id"
								:loading="product_loading"
								placeholder="请选择套餐"
								style="width:300px;"
							>
								<el-option
									v-for="(item, index) in product_list"
									:key="index"
									:label="item.product_name"
									:value="item.id"
								/>
							</el-select>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="AccessApi2">
			<div class="AccessFromBox">
				<el-form ref="form" :rules="rules" :model="form" label-width="120px">
					<el-form-item label="提取数量:" prop="amount">
						<el-input
							type="number"
							v-model="form.amount"
							placeholder="请输入提取数量"
							@keydown.native="blockInvalidNumberKey"
						/>
					</el-form-item>
					<el-form-item label="协议:" prop="proxy_type">
						<el-radio-group v-model="form.proxy_type">
							<el-radio label="http">HTTP(S)</el-radio>
							<el-radio label="socks5">SOCKSS</el-radio>
						</el-radio-group>
					</el-form-item>
					<!-- <el-form-item label="认证方法:">
						<el-radio-group v-model="form.approve">
							<el-radio label="1">IP白名单</el-radio>
							<el-radio label="2">当前账号/密码</el-radio>
						</el-radio-group>
					</el-form-item> -->
						<el-form-item label="IP白名单:">
						<el-input placeholder="请输入IP(每行一条IP记录,最多5条)" type="textarea" rows="6" resize="none" v-model="form.ip_white"></el-input>
					</el-form-item>
					<!-- <el-form-item label="共享IP时效">
						<el-select style="width:100%" v-model="form.region" placeholder="请选择活动区域">
							<el-option label="不限" value=""></el-option>
							<el-option
								v-for="(item, index) in shared_options"
								:key="index"
								:label="item"
								:value="item">
							</el-option>
						</el-select>
					</el-form-item> -->
					<!-- <el-form-item v-if="type == 2" label="独享IP时效:" prop="expireUnify">
						<el-input v-model="form.expireUnify" placeholder="单位秒(s)"></el-input>
					</el-form-item> -->
					<!-- <el-form-item label="去重天数:" prop="repeat">
						<el-input
							type="number"
							v-model="form.repeat"
							placeholder="单位天(<360天)。默认一天去重"
							@keydown.native="blockInvalidNumberKey"
						/>
					</el-form-item> -->
					<!-- <el-form-item label="地域">
						<el-select v-model="form.province" placeholder="请选择省">
							<el-option label="不限省" value=""></el-option>
							<el-option
								v-for="(item, index) in province_options"
								:key="index"
								:label="index"
								:value="index">
							</el-option>
						</el-select>
						<el-select style="margin-left:20px" v-model="form.city" placeholder="请选择市">
							<el-option label="不限市" value=""></el-option>
							<el-option
								v-for="(items, indexs) in province_options[form.province]"
								:key="indexs"
								:label="items"
								:value="items">
							</el-option>
						</el-select>
					</el-form-item> -->
					<!-- <el-form-item label="ISP">
						<el-select style="width:100%" v-model="form.carrier" placeholder="请选择ISP">
							<el-option label="不限" value=""></el-option>
							<el-option
								v-for="(item, index) in isps"
								:key="index"
								:label="item"
								:value="item">
							</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="IP返回格式:">
						<el-radio-group v-model="form.format">
							<el-radio label="json">JSON</el-radio>
							<el-radio label="txt">文本</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="换行方式" v-if="form.format == 'txt'">
						<el-select style="width:100%" v-model="form.splitter" placeholder="请选择活动区域">
							<el-option label="\n" value="n"></el-option>
							<el-option label="\r" value="r"></el-option>
							<el-option label="\r\n" value="rn"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit('form')">生成API</el-button>
						<el-tooltip class="item" effect="dark" content="点击查看更多帮助" placement="right">
							<i @click.stop="jumpNewHelp()" class="el-icon-question _elIcon"></i>
						</el-tooltip>
						
						<!-- <el-button>取消</el-button> -->
					</el-form-item>
				</el-form>
			</div>
			<div class="CopyBox">
				<div class="_top">
					<p class="_title">IP地址 <span>(请复制下面的链接地址，在新的浏览器或者标签页打开并查看)</span></p>
					<div class="_cont">
						<el-input v-model="IP_url"></el-input>
						<p @click.stop="copyUrl(IP_url)">复制链接</p>
						<p @click.stop="openUrl(IP_url)">打开链接</p>
					</div>
				</div>
				<!-- <div class="_top">
					<p class="_title">共享IP <span>(请复制下面的链接地址，在新的浏览器或者标签页打开并查看)</span></p>
					<div class="_cont">
						<el-input v-model="form.name"></el-input>
						<p>复制链接</p>
						<p>打开链接</p>
					</div>
				</div> -->
				<template v-if="false">
					<div class="_bot" v-show="type == '独享代理'">
						<span class="_title">使用示例</span>
						<p class="_p"><span class="_t1">接口调用</span>: http://api.caihongdaili.com/proxy/unify/get?token=TOKEN&product_type=exclusive&proxy_type=socks5&amount=1&expire=1000</p>
						<p class="_p"><span class="_t1">请求方法</span>：GET</p>
						<p class="_p"><span class="_t1">接口参数</span>：</p>
						<div class="sample_Bg">
							<el-table
								:data="tableData1"
								border
								style="width: 100%">
								<el-table-column
									prop="date"
									label="名称"
									width="180">
								</el-table-column>
								<el-table-column
									prop="type"
									label="类型"
									width="180">
								</el-table-column>
								<el-table-column
									prop="choose"
									width="80"
									label="必选">
								</el-table-column>
								<el-table-column
									prop="explain"
									label="说明">
								</el-table-column>
							</el-table>
						</div>
						<p class="_t1">返回参数示例：</p>
						<div class="_html" v-html="alonehtml1"></div>
						<p class="_t1">错误返回值示例：</p>
						<div class="_html" v-html="alonehtml2"></div>
						<p class="_t1">注意</p>
						<div class="_alonehtml3" v-html="alonehtml3"></div>
					</div>
					<div class="_bot" v-show="package_id !== ''">
						<span class="_title">使用示例</span>
						<p class="_p"><span class="_t1">接口调用</span>: http://api.caihongdaili.com/proxy/shared/get?token=TOKEN&proxy_type=socks5&amount=1&expire=5-30</p>
						<p class="_p"><span class="_t1">请求方法</span>：GET</p>
						<p class="_p"><span class="_t1">接口参数</span>：</p>
						<div class="sample_Bg">
							<el-table
								:data="tableData2"
								border
								style="width: 100%">
								<el-table-column
									prop="date"
									label="名称"
									width="180">
								</el-table-column>
								<el-table-column
									prop="type"
									label="类型"
									width="180">
								</el-table-column>
								<el-table-column
									prop="choose"
									width="80"
									label="必选">
								</el-table-column>
								<el-table-column
									prop="explain"
									label="说明">
								</el-table-column>
							</el-table>
						</div>
						<p class="_t1">返回参数示例：</p>
						<div class="_html" v-html="publichtml1"></div>
						<p class="_t1">错误返回值示例：</p>
						<div class="_html" v-html="publichtml2"></div>
						<p class="_t1">注意</p>
						<div class="_alonehtml3" v-html="publichtml3"></div>
					</div>
				</template>
			</div>
		</div>
		<div class="dialog-bg" v-if="show">
			<div class="dialog-content">
				<div class="close-box" @click="hideOrderTips">
					<i class="el-icon-close" />
				</div>
				<i class="el-icon-success" />
				<div class="main-title">恭喜您，套餐已购买成功!</div>
				<div class="sub-title">请选择已有套餐生成API</div>
				<div class="qrcode-box">
					<img :src="pageData ? pageData.wx_qrcode : ''" class="qrcode">
					<div class="info">
						<div class="main">可以扫描二维码添加客服</div>
						<div class="sub">进行咨询</div>
					</div>
				</div>
			</div>
		</div>
		<Foot />
	</div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import Foot from '@/components/Foot.vue'
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";
export default {
	name:'AccessApi',
	components: {
    Nav,
    Foot
	},
	data(){
		return {
			type:'',
			AccessNum:'',
			Num_options:[],
			IP_url:'',
			form: {
				amount: '',
				proxy_type: 'http',
				ip_white: '',
				repeat:'',
				format:'json',
				splitter:'n',
				carrier:'',
			},
			rules:{
				amount:[
					{ required: true, message: '请输入提取数量', trigger: 'blur' },
					{ validator: this.validateGreaterThan1Int, trigger: 'blur' },
				],
				proxy_type:[
					{ required: true, message: '请选择协议', trigger: 'change' },
				],
				repeat:[
					{ required: true, message: '请输入去重天数', trigger: 'blur' },
					{ validator: this.validateGreaterThan1Int, trigger: 'blur' }
				]
			},
			infoData:null,
			readAreaList:[],
			province_options:[],
			isp_options:[],
			isps:['电信','联通'],
			shared_options:[],
			msg:'',
			package_id: '',
			product_list: [],
			product_loading: false,
			loading_text:'获取套餐列表中...',
			show: false,
			publichtml1:`<pre class="line-numbers">
				<code class="language-json">
				{
					"msg": null,
					"status": 0, //status为0表示成功，若status不为0，错误信息如msg域所示
					"data": [{
							"ip": "220.186.138.99",//ip为您可以使用的代理IP,
							"http_port": "34402",//HTTP代理使用方式,IP白名单 或 用户名密码验证
							"s5_port": "34403",//SOCKS5代理使用方式,IP白名单 或 用户名密码验证
							"expire_at_timestamp": "1599119590",//该代理IP到期时间时间戳
							"filter": {
							"province": "浙江省",//代理IP省份
							"city": "温州市",//代理IP城市
							"carrier": "电信"//代理IP运营商
						}
					}]
				}
				</code></pre>`,
			alonehtml1:`<pre class="line-numbers">
				<code class="language-json">
				{
					"msg": null,
					"status": 0, //status为0表示成功，若status不为0，错误信息如msg域所示
					"data": [{
						"id": 1919284810, //id,可传入“四、释放占用资源”释放该IP
						"ip": "182.38.33.195", //ip为您可以使用的代理IP,
						//ip可传入“四、释放占用资源”释放该IP
						"http_port": "34408", //HTTP代理使用方式,IP白名单验证
						"http_port_secured": "34408", //HTTP代理使用方式,用户名密码验证
						"s5_port": "34409", //SOCKS5代理使用方式,IP白名单验证
						"s5_port_secured": "34409", //SOCKS5代理使用方式,用户名密码验证
						"expire_at_timestamp": "1599033456",//该代理IP到期时间时间戳
						"filter": {
							"province": "山东省", //代理IP省份
							"city": "威海市", //代理IP城市
							"carrier": "电信" //代理IP运营商
						}
					}]
				}
				</code></pre>`,
			publichtml2:`<pre class="line-numbers">
				<code class="language-json">
				{
					"status":700,
					"data":null,
					"msg":"Account Balance is not enough" //账号余额不足，请充值后再次提取
				}
				</code></pre>
				<pre class="line-numbers">
				<code class="language-json">
				{
					"status": 700,
					"data": {
						"valid": 0, //可用的总IP数量
						"required": 1 //当前请求的IP数量
					},
					"msg": "no enough line resource" //可用资源不足，请稍后再次提取或联系客服人员
				}
				</code></pre>`,
			alonehtml2:`<pre class="line-numbers">
				<code class="language-json">
				{
					"status":700, //status若为700，说明无法获取请求的资源
					"data":{
						"valid":0, //可用的总线路数量
						"required":5 //当前请求的线路数量
					},
					"msg":"no enough line resource"
				}
				</code></pre>
				<pre class="line-numbers">
				<code class="language-json">
				{
					"status":701, //status若为701，说明已经达到账号限制，请先释放掉已经占用的资源
					"data":{
						"current":3, //当前占用数量
						"valid":0,
						"required":5
					},
					"msg":"line resource limit"
				}
				</code></pre>`,
			publichtml3:`
				1. <span style="font-weight: bolder;">收费</span>：IP提取不收费，一个IP一旦使用，按单个IP相应价格扣费。<br>
				2. <span style="font-weight: bolder;">用户名密码认证</span>：输入登录官网的用户名密码进行认证。<br>
				3. <span style="font-weight: bolder;">IP白名单授权</span>：将使用代理IP的公网IP加入白名单。<br>
				<span style="padding-left:30px"></span>自动添加IP白名单：调用 “二、提取代理" 接口时添加 auto_ whitelist=true 参数，当前调用
				该接口的公网IP自动加入白名单，仅对本次提取的IP有效<br>
				<span style="padding-left:30px"></span>手动添加IP白名单：(每个用户20个白名单，更多白名单请联系客服人员)<br>
				<span style="padding-left:50px"></span>进入官网(http://www.caihongdaili.com/)页面<br>
				<span style="padding-left:50px"></span>点击官网右上角 “登录/注册”，进行登录或注册<br>
				<span style="padding-left:50px"></span>点击官网右上角 “个人中心” 进入用户 “基本信息” 页面<br>
				<span style="padding-left:50px"></span>“基本信息” 页面中，添加IP白名单<br>
				4. <span style="font-weight: bolder;">API调用频率</span>：请勿过度频繁调用提取IP接口，单个账号暂时支持30次/s。1s只会正常响应30次IP
				提取请求，过多的请求会返回相应提示信息。<br>
				5. <span style="font-weight: bolder;">地区</span>：province 和 city 参数 请参考 “五、可用地区列表”。`,
			alonehtml3:`
				1. <span style="font-weight: bolder;">线路</span>：获取接口只会返回新的可用线路。若当前在用未过期且未释放线路已满，请释放IP后再获取
				新的IP。<br>
				2. 为了您的正常使用，建议参考 “四、释放占用资源” 释放线路，以免IP使用时长过短出现释放延
				迟。<br>
				3. <span style="font-weight: bolder;">用户名密码认证</span>：输入登录官网的用户名密码进行认证。<br>
				4. <span style="font-weight: bolder;">IP白名单授权</span>：将使用代理IP的公网IP加入白名单。<br>
				<span style="padding-left:30px"></span>自动添加IP白名单：调用 “二、提取代理" 接口时添加 auto_ whitelist=true 参数，当前调用
				该接口的公网IP自动加入白名单<br>
				<span style="padding-left:30px"></span>手动添加IP白名单：(每个用户20个白名单，更多白名单请联系客服人员)<br>
				<span style="padding-left:50px"></span>进入官网(http://www.caihongdaili.com/)页面<br>
				<span style="padding-left:50px"></span>点击官网右上角 “登录/注册”，进行登录或注册<br>
				<span style="padding-left:50px"></span>点击官网右上角 “个人中心” 进入用户 “基本信息” 页面<br>
				<span style="padding-left:50px"></span>“基本信息” 页面中，添加IP白名单<br>
				5. <span style="font-weight: bolder;">API调用频率</span>：请勿过度频繁调用提取IP接口，单个账号暂时支持30次/s。1s只会正常响应30次IP
				提取请求，过多的请求会返回相应提示信息。<br>
				6. <span style="font-weight: bolder;">地区</span>：province 和 city 参数 请参考 “五、可用地区列表”。`,
			html2:``,
			tableData1:[
				{
					date: 'token',
					type: 'String',
					choose:'是',
					explain: '用户token，使用 ”一、获取Token/登录“ 获取'
				},
				{
					date: 'product_type',
					type: 'String',
					choose:'是',
					explain: '产品类型，固定参数，exclusive'
				},
				{
					date: 'proxy_type',
					type: 'String',
					choose:'是',
					explain: '代理类型，http 或 socks5'
				},
				{
					date: 'amount',
					type: 'Integer',
					choose:'是',
					explain: '提取的IP个数'
				},
				{
					date: 'expire',
					type: 'String',
					choose:'是',
					explain: `IP时效
					具体取值参见网站产品列表（例如 5-30、30-180、180-360，分别对应产品：5~30分钟、30分钟~3小时、3~6小时）`
				},
				{
					date: 'repeat',
					type: 'Integer',
					choose:'否',
					explain: '去重天数，单位天(<360天)。无此参数默认一天去重'
				},
				{
					date: 'format',
					type: 'String',
					choose:'否',
					explain: '数据结构，txt或json。无此参数默认返回json格式'
				},
				{
					date: 'splitter',
					type: 'String',
					choose:'否',
					explain: '分隔符。仅当format数据结构为txt时有效 r为使用\r分割，n为使用\n分割，rn为使用\r\n分割'
				},
				{
					date: 'province',
					type: '汉字',
					choose:'否',
					explain: '省份名称，按省份过滤。无此参数默认混拨'
				},
				{
					date: 'city',
					type: '汉字',
					choose:'否',
					explain: '城市名称，按城市过滤。无此参数默认混拨'
				},
				{
					date: 'carrier',
					type: '汉字',
					choose:'否',
					explain: '运营商名称，按运营商过滤，电信 或 联通。无此参数默认混拨'
				},
				{
					date: 'auto_whitelist',
					type: 'Boolean',
					choose:'否',
					explain: '智能白名单，当前调用该接口的公网IP自动加入IP白名单，仅对本次提取的IP有效。无此参数默认false'
				},
			],
			tableData2:[
				{
					date: 'token',
					type: 'String',
					choose:'是',
					explain: '用户token，使用 ”一、获取Token/登录“ 获取'
				},
				{
					date: 'proxy_type',
					type: 'String',
					choose:'是',
					explain: '代理类型，http 或 socks5'
				},
				{
					date: 'amount',
					type: 'Integer',
					choose:'是',
					explain: '提取的IP个数'
				},
				{
					date: 'expire',
					type: 'String',
					choose:'是',
					explain: `IP时效
					具体取值参见网站产品列表（例如 5-30、30-180、180-360，分别对应产品：5~30分钟、30分钟~3小时、3~6小时）`
				},
				{
					date: 'repeat',
					type: 'Integer',
					choose:'否',
					explain: '去重天数，单位天(<360天)。无此参数默认一天去重'
				},
				{
					date: 'format',
					type: 'String',
					choose:'否',
					explain: '数据结构，txt或json。无此参数默认返回json格式'
				},
				{
					date: 'splitter',
					type: 'String',
					choose:'否',
					explain: '分隔符。仅当format数据结构为txt时有效 r为使用\r分割，n为使用\n分割，rn为使用\r\n分割'
				},
				{
					date: 'province',
					type: '汉字',
					choose:'否',
					explain: '省份名称，按省份过滤。无此参数默认混拨'
				},
				{
					date: 'city',
					type: '汉字',
					choose:'否',
					explain: '城市名称，按城市过滤。无此参数默认混拨'
				},
				{
					date: 'carrier',
					type: '汉字',
					choose:'否',
					explain: '运营商名称，按运营商过滤，电信 或 联通。无此参数默认混拨'
				},
				{
					date: 'auto_whitelist',
					type: 'Boolean',
					choose:'否',
					explain: '智能白名单，当前调用该接口的公网IP自动加入IP白名单，仅对本次提取的IP有效。无此参数默认false'
				},
			],
		}
	},
	computed:{
		form_province(){
			return this.form.province
		},
		form_city(){
			return this.form.city
		},
		pageData() {
			return this.$store.state.pageData
		}
	},
	watch:{
		// 'form_city':{
		// 	handler(value){
		// 		var isps = [];
		// 		if (this.form.province=="") return;
		// 		if (value=='') {
		// 			//不限市
		// 			var citys = this.province_options[this.form.province];
		// 			for (var k in citys) {
		// 				var isparr = this.isp_options[citys[k]];
		// 				for (var j in isparr) {
		// 					if (!this.inArray(isps, isparr[j])) {
		// 						isps.push(isparr[j]);
		// 					}
		// 				}
		// 			}
		// 		} else {
		// 			//获取ISP
		// 			var isparr = this.isp_options[value];
		// 			for (var j in isparr) {
		// 				if (!this.inArray(isps, isparr[j])) {
		// 					isps.push(isparr[j]);
		// 				}
		// 			}
		// 		}
				
		// 		this.isps = isps;
		// 		if (!this.inArray(this.isps, this.form.carrier)) {
		// 			this.form.carrier = '';
		// 		}
		// 	},
		// 	deep: true 
		// },
		// 'form_province':{
		// 	// province
		// 	handler(value){
		// 		//换城市
		// 		this.form.city = '' 
		// 		var isps = [];
		// 		if (value=='') {
		// 			//不限省
		// 			for (var pro in this.province_options) {
		// 				var citys = this.province_options[pro];
		// 				for (var i in citys) {
		// 					var isparr = this.isp_options[citys[i]];
		// 					for (var j in isparr) {
		// 						if (!this.inArray(isps, isparr[j])) {
		// 							isps.push(isparr[j]);
		// 						}
		// 					}
		// 				}
		// 			}
		// 		} else {
		// 			//获取ISP
		// 			var citys = this.province_options[value];
		// 			for (var i in citys) {
		// 				var isparr = this.isp_options[citys[i]];
		// 				for (var j in isparr) {
		// 					if (!this.inArray(isps, isparr[j])) {
		// 						isps.push(isparr[j]);
		// 					}
		// 				}
		// 			}
		// 		}
				
		// 		this.isps = isps;
		// 		if (!this.inArray(this.isps, this.form.carrier)) {
		// 			this.form.carrier = '';
		// 		}
		// 	},
		// 	immediate: true,
		// 	deep: true 
		// }
	},
	created(){
		this.getInfoData()
		// this.getreadAreaList()
		this.getreadProductList()
		this.getOrder()
	},
	mounted(){
		setTimeout(()=>{
			Prism.highlightAll()
		},0)
	},
	methods:{
		showOrderTips() {
			this.show = true
			document.body.style.overflow = 'hidden'
		},
		hideOrderTips() {
			this.show = false
			document.body.style.overflow = ''
		},
		getOrder() {
			request({
				method: "get", 
				url: Apis.queryOrder,
				params:{
					access_token:localStorage.getItem('access_token')
				}
			}).then(res => {
				if (res.code == 0) {
					if (res.data.is_order) {
						this.showOrderTips()
					}
				}
			})
		},
		blockInvalidNumberKey(e) {
			if (['e', 'E', '.', '-', '+'].includes(e.key)) {
				e.preventDefault()
			}
		},
		validateGreaterThan1Int(rule, value, callback) {
			// 先转字符串判断前导零
			const str = String(value).trim()

			// 禁止前导零：长度>1 且以 0 开头
			if (str.length > 1 && str.startsWith('0')) {
				return callback(new Error('请输入有效数字'))
			}

			// 数字校验
			const num = Number(value)
			if (!value || isNaN(num)) {
				return callback(new Error('请输入有效数字'))
			}
			if (!Number.isInteger(num)) {
				return callback(new Error('只能输入整数'))
			}
			if (num < 1) {
				return callback(new Error('必须输入大于1的正整数'))
			}
			if (num >= 360) {
				return callback(new Error('必须输入小于360的整数'))
			}

			callback()
		},
		inArray(arr, val){
			for (var i in arr) {
				if (arr[i]==val) {
					return true;
				}
			}
			return false;
		},
		jumpNewHelp(){
			this.$router.push({path: `/newhelp`})
		},
		jumpTopup(){
			this.$router.push({ path: '/topup' })
		},
		onSubmit(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if(this.package_id == ''){
						this.$message({
							message: '请选择套餐',
							showClose: true,
							duration:1500,
							type: 'warning'
						});
						return;
					}
					let access_token = localStorage.getItem('access_token')
					var data = {
						package_id: this.package_id,
						access_token:access_token,
						amount:this.form.amount,
						proxy_type:this.form.proxy_type,
						ip_white:this.form.ip_white,
						format:this.form.format
					}
					if (this.form.format == 'txt'){
						data.splitter = this.form.splitter
					}
					this.getAccess(data)
				} else {
					return false;
				}
			});
		},
		getAccess(data){
			request({
				method: "get", 
				url: Apis.readAPIMold,
				params:data
			}).then(res => {
				if(res.code == 0){
					this.$message({
						message: '获取成功',
						showClose: true,
						duration:1500,
						type: 'success'
					});
					this.IP_url = res.data
				}else if (res.code == -10){
					this.$confirm(res.msg, '提示', {
						confirmButtonText: '去实名',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						await this.$store.commit("setMineActiveLi", 1);
						this.$router.push({ path: '/mine' })
					}).catch(() => {
						       
					});
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		copyUrl(){
			if (!this.IP_url) {
				this.$message.warning('请先获取IP地址')
				return
			}
			var Url2=this.IP_url;
			var oInput = document.createElement('input');
			oInput.value = Url2;
			document.body.appendChild(oInput);
			oInput.select(); // 选择对象
			document.execCommand("Copy"); // 执行浏览器复制命令
			oInput.className = 'oInput';
			oInput.style.display='none';
			this.$message({
				message: '复制成功',
				showClose: true,
				duration:1500,
				type: 'success'
			});
		},
		openUrl(){
			if (!this.IP_url) {
				this.$message.warning('请先获取IP地址')
				return
			}
			window.open(this.IP_url)
		},
		getreadAreaList(){
			let access_token = localStorage.getItem('access_token')
			let data = {
				access_token:access_token
			}
			request({
				method: 'get', 
				url: Apis.readAreaList,
				params:data
			}).then(res => {
				if(res.code == 0){
					this.province_options = res.data.area
					this.isp_options = res.data.isp
					this.form.province = '1';
					this.form.province = '';
				}else{
					this.$message.error(res.msg);
				}
			});
		},
		getInfoData(){
			let access_token = localStorage.getItem('access_token')
			let data = {
				access_token:access_token
			}
			request({
				method: 'get', 
				url: Apis.readMemberInfo,
				params:data
			}).then(res => {
				if(res.code == 0){
					this.infoData = res.data
					this.$store.commit("setMineData", res.data);
					this.form.ip_white = res.data.ip_white
				}else{
					this.$message.error(res.msg);
				}
			});
		},
		getreadProductList(){
			this.product_loading = true
			let data = {
				access_token:localStorage.getItem('access_token')
			}
			request({
				method: 'get', 
				url: Apis.getMyProductList,
				params:data
			}).then(res => {
				if(res.code == 0){
					this.product_list = res.data
				}else{
					this.$message.error(res.msg);
				}
				this.product_loading = false
			});
		}
	}
}
</script>

<style lang="less" scoped>
.AccessApiBox{
	width: 100%;
	position: relative;
	background: #fff;
	._CONT{
		width: 100%;
		background: #F9F9F9;
		.AccessApi1{
			width: 1200px;
			margin: 0 auto;
			._AccessTop{
				width: 100%;
				height: 324px;
				._top{
					width: 100%;
					display: flex;
					justify-content: space-around;
					._left , ._right{
						width: 564px;
						height: 177px;
						background: #fff;
						margin-top: 33px;
						padding: 20px 40px;
						position: relative;
						._title{
							font-size: 22px;
							color:#1E1D1D;
							font-weight: bold;
							// padding: 10px 0;
						}
						._cont{
							font-size: 18px;
							color: #5C6872;
							line-height: 40px;
							margin-top: 20px;
						}
						._p1{
							font-size: 18px;
							color: #1E1D1D;
							text-align: left;
							margin-top: 20px;
							padding-left: 10px;
						}
						._p2{
							font-size: 48px;
							font-weight: bold;
							color: #E21A81;
							margin-top: 10px;
							text-align: left;
							padding-left: 10px;
						}
						._right_button{
							width: 120px;
							height: 50px;
							border-radius: 6px;
							background: #1F8EFF;
							color: #fff;
							font-size: 18px;
							font-weight: bold;
							line-height: 50px;
							position: absolute;
							right: 20px;
							bottom: 20px;
							cursor:pointer;
						}
					}
				}
				._bot{
					width: 100%;
					height: calc(100% - 210px);
					display: flex;
					justify-content: center;
					align-items: center;
					._selects{
						margin-left: 10px;
					}
					._right{
						margin: 50px;
					}
				}
			}
		}
	}
	.AccessApi2{
		width: 1200px;
		margin: 0 auto;
		min-height: 800px;
		padding: 20px 20px 20px 0;
		.AccessFromBox{
			width: 100%;
			text-align: left;
		}
		.CopyBox{
			width: 100%;
			text-align: left;
			padding: 0 5px 0 40px;
			._top{
				width: 100%;
				margin-top: 20px;
			}
			._bot{
				margin-top: 30px;
				// display: none;
				p{
					margin: 15px 0 15px 20px;
				}
				.sample_Bg{
					margin-top: 10px;
					padding: 20px;
					// background: #EDF7FF;
					// padding-bottom: 20px;
					p{
						font-size: 14px;
						color: #464C50;
						white-space:pre
					}
				}
				._html{
					// padding: 20px;
				}
				._alonehtml3{
					padding: 0 20px;
					font-size: 15px;
					line-height: 26px;
				}
			}
			._title{
				font-size: 20px;
				font-weight: bolder;
				span{
					display: inline-block;
					font-size: 14px;
					font-weight: 400;
					position: relative;
					// top:-5px;
					// line-height: -10px;
				}
			}
			._cont{
				width: 100%;
				display: flex;
				margin-top: 10px;
				p{
					margin-left: 10px;
					width: 110px;
					height: 40px;
					border-radius: 6px;
					border: 1px solid #2595ff;
					background: #e8f4fb;
					color: #2595ff;
					text-align: center;
					line-height: 40px;
					font-size: 15px;
					// font-weight: bold;
					cursor: pointer;
				}
			}
		}
	}
	.red{
		color: #F56C6C;
		margin-right: 3px;
	}
	.dialog-bg{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 100;
		background-color: rgba(0,0,0,0.75);
		display: flex;
		justify-content: center;
		align-items: center;
		.dialog-content{
			width: 550px;
			height: 475px;
			background-color: #fff;
			padding: 0 0 45px 0;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			.close-box{
				width: 100%;
				height: 45px;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				padding-right: 10px;
				.el-icon-close{
					cursor: pointer;
					font-size: 30px;
					color: #AAAAAA;
				}
			}
			.el-icon-success{
				color: #69DD56;
				font-size: 100px;
			}
			.main-title{
				font-size: 20px;
				font-weight: bold;
				color: #000;
				margin: 40px 0 15px 0;
			}
			.sub-title{
				font-size: 14px;
				margin-bottom: 30px;
			}
			.qrcode-box{
				width: calc(100% - 100px);
				height: 150px;
				margin: 0 auto;
				background-color: #F6F7FB;
				padding: 15px 25px;
				display: flex;
				justify-content: center;
				align-items: center;
				.qrcode{
					width: 120px;
					height: 120px;
				}
				.info{
					width: calc(100% - 120px);
					height: 100%;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: flex-start;
					font-size: 14px;
					color: #AAA;
					padding-left: 35px;
					.main{
						margin-bottom: 10px;
					}
				}
			}
		}
	}
}
._t1{
	font-weight: bold;
	font-size: 16px;
	// margin-bottom: 20px;
}
._label{
	// width: 140px;
	text-align: left;
	padding-left: 10px;
	position: relative;
	line-height: 30px;
	font-weight: bold;
	font-size: 20px;
	left: 10px;
}
._label::after{
	content: '';
	display: inline-block;
	width: 4px;
	height: 23px;
	background: #51B3FF;
	position: absolute;
	top: 5px;
	left: 0px;
}
._elIcon{
	font-size: 25px;
	position: relative;
	top: 5px;
	left: 20px;
	color: #1F8EFF;
	cursor: pointer;
}

</style>